<template>
<div
      class="checkbox-toggle"
      role="checkbox"
      @onclick="toggle"
      @click.stop="toggle"
      tabindex="0"
      :aria-checked="toggled"
>
  <div
        v-show="showLabels"
        class="checkbox-label"
        v-html="label"
  ></div>
  <div
        class="checkbox-slide"
        :class="classes"
  >
    <div
          class="checkbox-switch"
          :class="classes"
    ></div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true
    },

    ontoggle: {
      type: Function,
      default: () => {},
    },

    disabled: {
      type: Boolean,
      default: false
    },

    showLabels: {
      type: Boolean,
      default: false
    },

    labelChecked: {
      type: String,
      default: ""
    },

    labelUnchecked: {
      type: String,
      default: ""
    }
  },

  watch: {
    value: {
      handler(value) {
        this.toggled = value
      },
      immediate: true
    }
  },

  computed: {
    classes: function() {
      return {
        checked: this.value,
        unchecked: !this.value,
        disabled: this.disabled
      };
    },

    label: function() {
      return this.value && this.showLabels ?
        this.labelChecked :
        this.labelUnchecked;
    }
  },

  methods: {
    toggle: function(e) {
      if (this.disabled) { // not if disabled
        e.stop();
      }

      this.toggled = !this.toggled;
      this.$emit("input", this.toggled);
      this.ontoggle()
    }
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>
<style lang="scss">
@import '../assets/variables.scss';
.checkbox-toggle {
    $slideWidth: 2.7em;
    $borderRadius: 0.25em;

    $switchWidth: $slideWidth/2;
    $switchHeight: $slideWidth/2;

    $distance: $slideWidth/2;

    $switchColor: $gray;
    $sliderColorActive: lighten($newBlue, 5%);
    $sliderColorInactive: $lightText;

    $transitionTime: 350ms;

    outline: none;
    // width: $slideWidth * 3;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: 0.1em 0.1em 0.1em 0;

    .checkbox-slide {
        padding: 0;
        margin: 0;
        border-radius: 0.25em;
        cursor: pointer;
        min-width: $slideWidth;
    }

    .checkbox-switch {
        padding: 0;
        margin: 0;
        width: $switchWidth;
        height: $switchHeight;
        border-radius: $borderRadius;
        background: $switchColor;
        cursor: pointer;
    }

    .checkbox-label {
        margin-right: 0.5em;
        white-space: nowrap;
        font-weight: bold;
        font-size: 15px;
    }

    .checkbox-switch.checked {
        transform: translateX($distance);
        transition: all $transitionTime;
    }

    .checkbox-switch.unchecked {
        transition: all $transitionTime;
    }

    .checkbox-slide.checked {
        transition: all $transitionTime;
        background: $sliderColorActive;
    }

    .checkbox-slide.unchecked {
        transition: all $transitionTime;
        background: $sliderColorInactive;
    }

    .checkbox-switch.disabled {
        cursor: not-allowed;
        background: lighten($switchColor, 35%);
    }

    .checkbox-slide.disabled {
        cursor: not-allowd;
        background: lighten($sliderColorInactive, 5%);
    }
}
</style>
